import { render } from "./ViewNatalChart.vue?vue&type=template&id=dd93a9c6&scoped=true"
import script from "./ViewNatalChart.vue?vue&type=script&lang=js"
export * from "./ViewNatalChart.vue?vue&type=script&lang=js"

import "./ViewNatalChart.vue?vue&type=style&index=0&id=dd93a9c6&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2784445594/src/vedicastrochart-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd93a9c6"]])

export default __exports__